import React, { Component } from 'react';
import { Redirect } from 'react-router';
import DocumentMeta from 'react-document-meta';
import { CATEGORIES, ROOT_DIR, LOCATION, DOMAIN } from '../../utils/Constants';
import SectionLoader from '../pieces/SectionLoader';
import Social from '../blocks/Social';
import ListItems from '../blocks/ListItems';
import PriorityListItems from '../blocks/PriorityListItems';
import ImageLoader from '../pieces/ImageLoader';
import GeneralUtil from '../../utils/GeneralUtil';

class Listing extends Component {

  state = {
    imageStatus: 'loading',
    validCat: true
  }
  
  componentDidMount(){
    window.scrollTo(500, 0);
    if(this.checkValidCat(this.props.match.params.dir)){
      this.props.getTypeFromDir(this.props.match.params.dir, true);
      console.log(this.props.type);
      this.props.getPriorityList(this.props.match.params.dir);
    }
    else {
      this.setState({ validCat: false });
    }
    
  }
  componentWillReceiveProps(nextProps){
    if(this.props.match.params.dir !== nextProps.match.params.dir){
      if(this.checkValidCat(nextProps.match.params.dir)){
        this.props.getTypeFromDir(nextProps.match.params.dir, true);
        this.props.getPriorityList(nextProps.match.params.dir);
        this.setState({ imageStatus: 'loading' });
      }
      else {
        this.setState({ validCat: false });
      }
      
    }
  }
  handleImageLoaded = () => {
   this.setState({ imageStatus: 'loaded' }); 
  }
  handleImageErrored = () => {
    this.setState({ imageStatus: 'error' });
  }
  checkValidCat = (cat) => {
    var valid = false;
    CATEGORIES.forEach((val, idx) => {
      if(cat === val.dir){
        valid = true;
      }
    });
    return valid;
  }
  render(){

    let list = this.props.list;
    let title = GeneralUtil.renderName(this.props.match.params.dir);
    
    const meta = {
      title: `― ${title} on ${LOCATION}, Essex, UK ―`,
      description: `${title} on ${LOCATION}, Essex, UK, business directory for ${LOCATION}`,
      canonical: `http://www.${DOMAIN}/businesses/${this.props.match.params.dir}`,
      meta: {
        keywords: `${title}, ${this.props.match.params.dir}, ${LOCATION}, Essex, United Kingdom, business listings, business directory, businesses`
      }
      
    };
    return(
      <div>
        <DocumentMeta {...meta} />
        {!this.state.validCat ? 
          <Redirect to="/" />
          :
          ''
        }
        <div className="banner innerpage-banner">
          <h1 className="innerpage-heading no-margin"><span className="business-type">{title}</span> in {LOCATION}</h1>
          <Social/>
          <ImageLoader
              imageStatus={this.state.imageStatus}
            />
          <picture>
              <source media="(min-width: 769px)" srcSet={`${ROOT_DIR}/assets/img/categories/${this.props.match.params.dir}-banner.jpg`}/>
              <source media="(max-width: 768px)" srcSet={`${ROOT_DIR}/assets/img/categories/${this.props.match.params.dir}-banner-mob.jpg`}/>
              <img 
                src={`${ROOT_DIR}/assets/img/categories/${this.props.match.params.dir}-banner.jpg`} 
                alt={`${title} on ${LOCATION}`} 
                onLoad={this.handleImageLoaded}
                onError={this.handleImageErrored}
                />
            </picture>
            
        </div>
        <div className="page-content-wrapper">
          <div className="row">
            <div className="large-12 columns page-content">
              <p>Choose from this list of {title} in {LOCATION}.</p>
              {this.props.priorityList.length > 0 && 
                <PriorityListItems
                  priorityList={this.props.priorityList}
                />
              }
              
            {this.props.loadingList ?
              <SectionLoader/>
            :

              <ListItems
                list={list}
                typeDir={this.props.typeDir}
              />
            }

              
                
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Listing;


// WEBPACK FOOTER //
// ./src/components/pages/Listing.js